import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Express';

    // override the default Preset here
}
